"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemContainerBase = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var ItemHost_1 = require("./ItemHost");
var ItemContainerBase = /** @class */ (function (_super) {
    __extends(ItemContainerBase, _super);
    function ItemContainerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemContainerBase.prototype.shouldComponentUpdate = function (nextProps) {
        return !(0, EqualityComparers_1.rectEqualityComparer)(nextProps.layoutRect, this.props.layoutRect) || nextProps.item !== this.props.item;
    };
    ItemContainerBase.prototype.renderItem = function () {
        return (0, jsx_runtime_1.jsx)(ItemHost_1.ItemHost, { itemRenderer: this.props.itemRenderer, item: this.props.item, itemIndex: this.props.itemIndex });
    };
    /* istanbul ignore next */
    ItemContainerBase.prototype.componentDidCatch = function (error, errorInfo) {
        if (_super.prototype.componentDidCatch) {
            _super.prototype.componentDidCatch.call(this, error, errorInfo);
        }
        // TODO: Unsure of best strategy for handling unexpected item failures
    };
    return ItemContainerBase;
}(React.Component));
exports.ItemContainerBase = ItemContainerBase;
//# sourceMappingURL=ItemContainerBase.js.map